import MainLayout from "../components/shared/MainLayout";
import Carousel from "../components/carousel/Carousel";
import ChooseUs from "../components/home/ChooseUs";
import RecentProjects from "../components/home/RecentProjects";
import Services from "../components/home/Services";

const Home = () => {
  return (
    <MainLayout>
      <Carousel />
      <ChooseUs />
      <RecentProjects />
      <Services />
    </MainLayout>
  );
};

export default Home;
